/**
 * Single source of truth for what each subscription tier grants.
 * Read by the API (entitlement checks) AND web (UI rendering).
 */
export const SUBSCRIPTION_TIERS = {
    none: {
        lessonsPerMonth: 0,
        imageSearch: false,
        imageGenerate: false,
        analysisPerDay: 0,
        // Free-tier (no active subscription) gets a small daily allowance.
        // Higher caps require a paid subscription. Adjusted from 500/500 during
        // the pre-launch audit — open free-tier was the largest cost-amplification
        // path for a signed-up but un-paid user (Phase 2 finding 10.2).
        chatMessagesPerDay: 10,
        aiGradingPerDay: 10,
        storageQuotaBytes: 0, // no uploads on the free tier
    },
    plus: {
        lessonsPerMonth: 30,
        imageSearch: false,
        imageGenerate: false,
        analysisPerDay: 10,
        chatMessagesPerDay: 500,
        aiGradingPerDay: 500,
        storageQuotaBytes: 1 * 1024 * 1024 * 1024, // 1 GB
    },
    pro: {
        lessonsPerMonth: 60,
        imageSearch: true,
        imageGenerate: false,
        analysisPerDay: 20,
        chatMessagesPerDay: 500,
        aiGradingPerDay: 500,
        storageQuotaBytes: 5 * 1024 * 1024 * 1024, // 5 GB
    },
    max: {
        lessonsPerMonth: 150,
        imageSearch: true,
        imageGenerate: true,
        analysisPerDay: 30,
        chatMessagesPerDay: 500,
        aiGradingPerDay: 500,
        storageQuotaBytes: 25 * 1024 * 1024 * 1024, // 25 GB
    },
};
/**
 * Per-user per-minute anti-abuse caps. Constant across tiers — paying users
 * shouldn't be able to burst faster than non-paying.
 */
export const PER_MINUTE_LIMITS = {
    analysisPerMinute: 5,
    chatMessagesPerMinute: 20,
    aiGradingPerMinute: 30,
};
/**
 * Role levels at or above this bypass all entitlement checks (internal staff).
 * Mirrors ROLE_LEVELS.CONTENT_MANAGER from core — duplicated here to keep
 * shared free of a core dependency.
 */
export const ENTITLEMENT_BYPASS_ROLE_LEVEL = 60;
//# sourceMappingURL=subscriptionTiers.js.map